"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecimalField = void 0;
const react_1 = __importDefault(require("react"));
const rifm_1 = require("rifm");
const big_js_1 = __importDefault(require("big.js"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const internal_state_hook_1 = require("../../utils/internal-state-hook");
const text_field_1 = require("../text-field/text-field");
function DecimalField({ value: providedValue = null, onChange: providedOnChange, negative = false, formated = false, maxValue, minValue, decimalDigits = 2, ...props }) {
    providedValue = providedValue != null ? providedValue : '0';
    const valueCondition = event_callback_hook_1.useEventCallback((value, externalValue) => {
        return value !== externalValue;
    });
    const changeCondition = event_callback_hook_1.useEventCallback((value) => {
        if (value === '') {
            return true;
        }
        else {
            const number = Number(value);
            if (!Number.isNaN(number)) {
                if (maxValue && number > maxValue) {
                    return false;
                }
                else if (minValue && number < minValue) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
    });
    const [value, setValue, synced] = internal_state_hook_1.useInternalState({ value: providedValue, onChange: providedOnChange }, valueCondition, changeCondition);
    const handleChange = event_callback_hook_1.useEventCallback((value) => setValue(parseNumber(value)));
    const accept = /[\d.]/g;
    const format = formatFloatingPointNumber;
    const rifm = rifm_1.useRifm({
        accept,
        format: (v) => format(v, decimalDigits),
        value,
        onChange: handleChange,
    });
    return (react_1.default.createElement(text_field_1.TextField, Object.assign({ value: rifm.value, onChangeEvent: rifm.onChange, error: !synced }, props)));
}
exports.DecimalField = DecimalField;
const numberAccept = /[\d.]+/g;
const parseNumber = (str) => (str.match(numberAccept) || []).join('');
const formatFloatingPointNumber = (value, maxDigits) => {
    const parsed = parseNumber(value);
    const big = big_js_1.default(parsed);
    const formatted = big.toFixed(maxDigits);
    return formatted;
};
//# sourceMappingURL=decimal-field.js.map